import { NEW_CSW } from 'shared/experiments/consts'
import { trackCswSlider } from 'shared/experiments/consts/trackCswSlider'
import { isExperimentEnabled } from 'shared/experiments/utils/experiments'

export default () => {
  if (!isExperimentEnabled(NEW_CSW)) {
    return
  }

  trackCswSlider({
    shouldTrackArrowClick: true,
    shouldTrackShowAllClick: true,
    shouldTrackShowMoreClick: true,
    shouldTrackWithWidgetIds: true,
  })
}
